import { SettingConst } from '../../types';

/**
 * Maximum number of search query suggestions to show in search suggestion results.
 */
export const MAX_NUM_SEARCH_QUERY_SUGGESTIONS_CONFIG =
  'MAX_NUM_SEARCH_QUERY_SUGGESTIONS_CONFIG' as SettingConst<
    'MAX_NUM_SEARCH_QUERY_SUGGESTIONS_CONFIG',
    number,
    'RETAILER'
  >;
